module.exports = __webpack_public_path__ + "static/media/cons.0f5d5393.jpeg";